query ListParameters {
    parameters {
        id
        guid

        name(language: "en") {
            text
        }

        dataType
        deprecated
    }
}
